import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { getUserLists, resetUserLists, setUserListsPage, toggleUserListModal } from '../../../redux/actions/userLists';
import { Virtuoso } from 'react-virtuoso';

import ActionTypes from '../../../redux/constants/action-types';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import { ListItem, ListItemButton, Radio, TextField, Menu, MenuItem, Divider, InputAdornment } from '@mui/material';
import useDidMountEffect from '../../utils/useDidMountEffect';
import useDebounce from '../../utils/useDebounceV2';
import { ListItemText } from '@material-ui/core';
import Create from './Create';

const LIST_PER_PAGE = 30;
const virtuosoStyle = { height: '350px' };
const DEBOUNCE_DELAY = 800;

const AddUserFromModal = ({
    userListsRdx,
    userListsPageRdx,
    listBusyRdx,
    userListsHasMoreRdx,
    userListsTotalRdx,
    userListModalRdx,
    conversationsRdx,
    convIndexRdx
}) => {
    const dispatch = useDispatch();

    const [userListSort, setUserListSort] = useState('name');
    const [order, setOrder] = useState('desc');
    const [anchorEl, setAnchorEl] = useState(null);
    const [keyword, setKeyword] = useState('');
    const [busy, setBusy] = useState(false);
    const [showNewForm, setShowNewForm] = useState(false);
    const [editList, setEditList] = useState({});
    const [selectedList, setSelectedList] = useState([]);
    const [showListMenu, setShowListMenu] = useState(false);

    const getLists = () => {
        const params = {
            page: userListsPageRdx,
            action: userListsRdx && userListsRdx.length > 0
                ? ActionTypes.APPEND_USER_LISTS
                : ActionTypes.SET_USER_LISTS,
            per_page: LIST_PER_PAGE,
            order: order,
            sort: userListSort,
            kw: keyword
        };
        dispatch(getUserLists(params));
    };

    const handleClose = (e, reason) => {
        if (reason && reason === "backdropClick") {
            return;
        };
        dispatch(toggleUserListModal(false));
        dispatch(resetUserLists());
    };

    const handleListEnd = () => {
        if (listBusyRdx) return;

        if (userListsHasMoreRdx) {
            dispatch(setUserListsPage(userListsPageRdx + 1));
        }
    };

    const handleKeywordChange = e => {
        const value = e.target.value;
        setKeyword(value);
    };

    const debounceUserListSearch = useDebounce(() => {
        dispatch(resetUserLists());
        getLists();
    }, [DEBOUNCE_DELAY]);

    useDidMountEffect(() => {
        debounceUserListSearch();
    }, [keyword]);

    useEffect(() => {
        if (userListsPageRdx) {
            getLists();
        }
    }, [userListsPageRdx]);

    const handleNewUserList = () => {
        setShowNewForm(true);
    };

    const handleListChange = (e, id = null) => {
        e.stopPropagation();
        e.preventDefault();
        let tmp = [...selectedList];
        const value = parseInt(id ? id : e.target.value);
        const index = tmp.indexOf(value);

        if (index >= 0) {
            tmp.splice(index, 1);
        } else {
            tmp.push(value);
        }

        setSelectedList([...tmp]);

        saveSelectedList(tmp);
    };

    const saveSelectedList = async (listIDs) => {
        const userID = conversationsRdx[convIndexRdx].user_b;
        setBusy(true);
        await axios.post('/api/user-list-users/add', {
            user_id: userID,
            list_ids: listIDs
        })
            .then(response => {
                setBusy(false);
                console.log("ðŸš€ ~ file: AddUserFromModal.js:121 ~ saveSelectedList ~ response:", response);
            })
            .catch(error => {
                setBusy(false);
                console.log("ðŸš€ ~ file: AddUserFromModal.js:124 ~ saveSelectedList ~ error:", error);
            });
    };

    // useEffect(() => {
    //     saveSelectedList();
    // }, [selectedList]);

    const getAssignedList = () => {
        const userID = conversationsRdx[convIndexRdx].user_b;
        axios.get('/api/user-list-users/by-user', {
            params: {
                user_id: userID
            }
        })
            .then(response => {
                setSelectedList(response.data.data);
            })
            .catch(error => {
                console.log("ðŸš€ ~ file: AddUserFromModal.js:147 ~ getAssignedList ~ error:", error);
            });
    };

    useEffect(() => {
        getAssignedList();
    }, []);

    const handleOpenUserListOption = e => {
        setAnchorEl(e.currentTarget);
        setShowListMenu(true);
    };

    const handleUserListSortChange = e => {
        setUserListSort(e.target.value);
    };

    const handleUserOrderChange = e => {
        setOrder(e.target.value);
    };

    useDidMountEffect(() => {
        dispatch(resetUserLists());
        getLists();
    }, [order, userListSort]);

    const handleClearKeyword = () => {
        setKeyword('');
    };


    return <React.Fragment>
        {showNewForm && <Create
            show={showNewForm}
            setShow={setShowNewForm}
            edit={editList}
            setEdit={setEditList}
        />}
        <Dialog
            className='user-list-form'
            open={userListModalRdx}
            onClose={handleClose}
            sx={{
                '& .MuiDialog-paper': {
                    maxWidth: '320px',
                    width: '320px',
                },
            }}
        >
            <DialogContent>
                <div className='add-user-from-modal'>
                    <div>
                        <TextField
                            id="keyword"
                            label="User List Name"
                            value={keyword}
                            onChange={handleKeywordChange}
                            size='small'
                            InputProps={{
                                endAdornment: (
                                    !!keyword
                                        ? <IconButton
                                            aria-label="clear text"
                                            onClick={handleClearKeyword}
                                            edge="end"
                                        >
                                            <i style={{ color: '#0097fe' }} className="fal fa-times search-clear-icon"></i>
                                        </IconButton>
                                        : ''
                                ),

                                startAdornment: (<InputAdornment position="start">kg</InputAdornment>)
                            }}
                            sx={{
                                borderRadius: 20
                            }}
                        />
                    </div>
                    <div>
                        <IconButton
                            aria-label="New User List"
                            onClick={handleOpenUserListOption}
                            aria-controls={showListMenu ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={showListMenu ? 'true' : undefined}
                        >
                            <i className="fa-solid fa-bars-sort icon"></i>
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            id="basic-menu"
                            open={showListMenu}
                            onClose={() => setShowListMenu(false)}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}
                            sx={{
                                '&.MuiMenu-root': {
                                    zIndex: 99999
                                }
                            }}
                        >
                            <MenuItem onClick={() => { }}>
                                <Radio
                                    value='created_at'
                                    checked={userListSort === 'created_at'}
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'created_at' }}
                                    onChange={handleUserListSortChange}
                                /> Recent
                            </MenuItem>
                            <MenuItem onClick={() => { }}>
                                <Radio
                                    value='name'
                                    checked={userListSort === 'name'}
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'name' }}
                                    onChange={handleUserListSortChange}
                                /> Name
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => { }}>
                                <Radio
                                    value='asc'
                                    checked={order === 'asc'}
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'asc' }}
                                    onChange={handleUserOrderChange}
                                /> Ascending
                            </MenuItem>
                            <MenuItem onClick={() => { }}>
                                <Radio
                                    value='desc'
                                    checked={order === 'desc'}
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'desc' }}
                                    onChange={handleUserOrderChange}
                                /> Descending
                            </MenuItem>
                        </Menu>
                    </div>
                </div>
                <div style={{ position: 'relative' }}>
                    <Virtuoso
                        style={{ height: '50vh' }}
                        totalCount={userListsTotalRdx}
                        data={userListsRdx}
                        atBottomThreshold='150'
                        endReached={handleListEnd}
                        itemContent={(index, uList) => <ListItem
                            key={uList.id}
                            className={`user-lists__item`}
                            style={{
                                overflowX: 'break-word'
                            }}
                            disableGutters
                        >
                            <ListItemButton onClick={(e) => handleListChange(e, uList.id)}>
                                <Radio
                                    name="radio-buttons"
                                    value={uList.id}
                                    checked={selectedList.includes(uList.id)}
                                    onChange={(e) => handleListChange(e, uList.id)}
                                />&nbsp; <ListItemText
                                    sx={{ margin: 0 }}
                                    primary={uList.name}
                                />
                            </ListItemButton>
                        </ListItem>}
                    />
                </div>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'space-between' }}>
                <Button
                    onClick={handleNewUserList}
                    disabled={busy}
                ><i className="fa-sharp fa-regular fa-plus"></i> &nbsp; New User List</Button>
                <Button
                    onClick={handleClose}
                    disabled={busy}
                >Close</Button>
            </DialogActions>
        </Dialog>
    </React.Fragment>;
};

const mapStateToProps = state => ({
    userListsRdx: state.userLists.userLists,
    userListsPageRdx: state.userLists.userListsPage,
    listBusyRdx: state.userLists.busy,
    userListsTotalRdx: state.userLists.userListsTotal,
    userListModalRdx: state.userLists.userListModal,
    userListsHasMoreRdx: state.userLists.userListsHasMore,
    conversationsRdx: state.message.convList,
    convIndexRdx: state.message.convIndex
});

export default connect(mapStateToProps)(AddUserFromModal);